import React from "react";
import { Img } from "@chakra-ui/react";

export interface BannerImageProps {
	width?: number;
	height?: number;
	src: string;
	alt?: string;
	link?: string;
}

function BannerImage({ width, height, src, alt = "" }: BannerImageProps) {
	if (width && height) {
		return (
			<Img
				style={{
					position: "static"
				}}
				width={width}
				height={height}
				src={src}
				alt={alt}
			/>
		);
	}

	return (
		<Img
			loading="lazy"
			maxWidth={1100}
			maxHeight={290}
			src={src}
			alt={alt}
			sx={{
				width: "100%",
				height: "100%"
			}}
		/>
	);
}

export default BannerImage;
